'use client'

import type {
  StoreFrontDto,
  StoreFrontOptionsDefaultViewEnum,
} from '@b-stock/listing-api-client'
import type { AllListingsFilters } from '@b-stock/search-api-client'

import { useListingSearch } from './ListingSearchContext'
import { useListingStateURLRectification } from './useListingStateURLRectification'

const ListingStateURLRectifier = ({
  allFilters,
  pageDefaultView,
  storefront,
  preserveIdInUrl,
}: {
  allFilters?: AllListingsFilters
  pageDefaultView?: StoreFrontOptionsDefaultViewEnum
  storefront?: StoreFrontDto
  preserveIdInUrl?: boolean
}) => {
  const { state, dispatch, rawCategoryThreshold, isPageSizeRemembered } =
    useListingSearch()

  // `state` carries the derived default threshold (or none, for flag-off
  // buyers). Write the buyer's explicit value to the URL instead, so the
  // default never becomes explicit and a shared threshold isn't rewritten
  // away before the flag resolves.
  const urlState =
    rawCategoryThreshold === undefined ||
    rawCategoryThreshold === state.filters.categoryThreshold
      ? state
      : {
          ...state,
          filters: {
            ...state.filters,
            categoryThreshold: rawCategoryThreshold,
          },
        }

  useListingStateURLRectification({
    allFilters,
    dispatch,
    pageDefaultView,
    state: urlState,
    storefront,
    preserveIdInUrl,
    isPageSizeRemembered,
  })

  return null
}

export default ListingStateURLRectifier
